module.exports = __webpack_public_path__ + "media/Audio15_q.bf051942.wav";